<template>
    <div :class="classes">
        <slot></slot>
    </div>
</template>

<script>
    import theme from './tile.scss';

    export default {
        name: 'tile',
        props: {
            danger: Boolean,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        computed: {
            classes() {
                return {
                    [this.theme.tile]: true,
                    [this.theme.isDanger]: this.danger,
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Tile.vue?95a0fc88